import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ProductTile, TextColor, TextSize } from '@as/cotopaxi';
import { useAemConfig } from '@as-react/common-components';
import { ProductImageSizesPortraitEnum } from '@as-react/common-types';
import { Box, Link, Price, Stack, TextAlpha } from '@yonderland/andes-react';
import { usePriceProps } from '../../hooks/usePriceProps';
import { getImageSourceSetByProductCode } from '../../util/ImageUtil';
import { getProductDetailUrl } from '../../util/ProductUtil';
const IMAGE_WIDTH = 72;
export const ProductTopFiveTile = ({ product, ranking }) => {
    var _a, _b, _c;
    const { productImageConfig, root, feature_toggles: { lowest_price_all }, } = useAemConfig();
    const activeColour = (_a = product.colours) === null || _a === void 0 ? void 0 : _a.find(colour => colour.colourId === product.colourId);
    const productUrl = getProductDetailUrl(product, root);
    const priceProps = usePriceProps({
        priceInformation: {
            prices: activeColour.prices,
            hasDiscount: activeColour.hasDiscount,
        },
        enablePriceReference: lowest_price_all,
    });
    const productContext = {
        productCode: product.productCode,
        productId: product.productId,
        activeColorId: product.colourId,
        brand: product.brand,
        title: product.title,
        image: getImageSourceSetByProductCode(product.productCode, activeColour.image, productImageConfig)[ProductImageSizesPortraitEnum.bundles],
        review: { score: (_b = product.productRating) !== null && _b !== void 0 ? _b : 0, amount: (_c = product.productReviews) !== null && _c !== void 0 ? _c : 0 },
    };
    const [width, height] = ProductImageSizesPortraitEnum.bundles.split('x').map(Number);
    return (_jsxs(ProductTile, { variant: "horizontal", product: productContext, children: [_jsx(ProductTile.Area, { area: "primary", children: _jsx(Link, { href: productUrl, variant: "secondary", testId: "product-tile-link", children: _jsx(ProductTile.Image, { width: width, height: height, containerOptions: {
                            mobile: {
                                spacing: { marginRight: 1.5 },
                                width: IMAGE_WIDTH,
                            },
                        } }) }) }), _jsx(ProductTile.Area, { area: "secondary", children: _jsxs(Stack, { flex: { grow: 1 }, children: [_jsx(Box, { flex: { grow: 1 }, children: _jsxs(Stack, { direction: "col", align: "start", justify: "between", flex: { grow: 1 }, children: [_jsxs(Stack, { direction: "col", align: "start", gap: { base: '1' }, children: [_jsx(Link, { href: productUrl, testId: "product_title", variant: "tertiary", children: _jsx(ProductTile.Title, { size: TextSize.SMALL }) }), _jsx(ProductTile.Rating, { amountSize: TextSize.XSMALL, amountColor: TextColor.SUBTLE })] }), !!priceProps && _jsx(Price, Object.assign({}, priceProps))] }) }), _jsx(Box, { flex: { shrink: 0 }, children: _jsx(Stack, { flex: { grow: 1 }, align: "end", children: _jsx(TextAlpha, { strong: true, color: "subtle", variant: "bodyXL", children: ranking }) }) })] }) })] }));
};
